import { Navigate } from "react-router-dom"
import { ROUTES } from "../services/constants"
import { useAuth } from "../hooks/useAuth"


export const ProtectedRoute = ({children}) => {
    const {user} = useAuth();
    if(!user) return <Navigate to={ROUTES.AUTH_ROUTE} />;
    return children;
}